<template>
  <div class="d-flex flex-column align-items-center justify-content-center text-center" style="min-height:100vh">
    <h1 class="display-4 fw-bold mb-2">500</h1>
    <p class="text-muted mb-4">
      서버에 문제가 발생했습니다. 잠시 후 다시 시도해주세요.
      <span v-if="reqId" class="d-block mt-2 small text-secondary">Request ID: {{ reqId }}</span>
    </p>
    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary" type="button" @click="goBack">이전으로</button>
      <router-link class="btn btn-success" :to="{ name: 'Dashboard' }">대시보드로</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error500',
  computed: {
    reqId() { return this.$route.query.reqId || ""; }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.back();
      else this.$router.push({ name: 'Dashboard' });
    },
  },
}
</script>
